import { get } from 'lodash';
import * as actionTypes from 'store/actions/wallpaper';

export const initialState = {
    wallpapper: {
        list: [],
        current: {}
    }
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const wallpaperReducer = (state = initialState, action) => {
    const { type, data } = action;
    switch (type) {
        case actionTypes.SET_LIST:
            const wallpapers = get(data, 'wallpapers', []);
            return {
                ...state,
                list: wallpapers
            };
        case actionTypes.SET_CURRENT:
            return {
                ...state,
                current: data
            };
        default:
            return state;
    }
};

export default wallpaperReducer;
